import axios from "axios";
import { useAppContext } from "../../context/AuthContext";
import Endpoints from "../../utils/Endpoints";
import { axiosConfig } from "../../utils/Utils";

interface KeywordsControllerType {
  axiosGetKeywordsList: Function;
  axiosAddKeyword: Function;
  axiosDeleteKeyword: Function;
  axiosUpdateKeyword: Function;
}

export function KeywordsController(): KeywordsControllerType {
  const { authData } = useAppContext();

  const axiosGetKeywordsList = () => {
    return axios.get(Endpoints.ARTICLE + "/keywords", axiosConfig(authData!.token));
  };

  const axiosAddKeyword = (data: any) => {
    return axios.post(Endpoints.ARTICLE + "/keywords", data, axiosConfig(authData!.token));
  };

  const axiosDeleteKeyword = (id: string) => {
    return axios.post(Endpoints.ARTICLE + "/keywords/" + id + "/delete", {}, axiosConfig(authData!.token));
  };

  const axiosUpdateKeyword = (id: string, data: any) => {
    return axios.post(Endpoints.ARTICLE + "/keywords/" + id, data, axiosConfig(authData!.token));
  };

  return {
    axiosGetKeywordsList,
    axiosAddKeyword,
    axiosDeleteKeyword,
    axiosUpdateKeyword,
  };
}

export type { KeywordsControllerType };
